import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import tw from 'twin.macro';
import Heading from '~components/Heading';

import Layout from '~components/Layout';
import SEO from '~components/SEO';

import { fsbgmedia } from '~theme';

const MessagePage: React.FC = () => (
  <Layout>
    <SEO title="Messages from Our Leaders" desc="" />
    <div tw="relative pt-16">
      <div tw="relative z-20">
        <Heading level="h1" tw="text-center">
          Messages from Our Leaders
        </Heading>
        <StaticImage src="../images/leaders-hero.png" css={tw`w-full h-auto`} alt="" />
      </div>
      <StaticImage src="../images/message-bg.jpg" alt="" css={fsbgmedia} />
    </div>
    <div tw="bg-gray-100 py-12">
      <div tw="container">
        <div tw="my-8 lg:(grid grid-cols-3 my-12)">
          <div tw="lg:(col-span-1 -mr-12 mt-12)">
            <StaticImage src="../images/kathryn.jpg" alt="" />
          </div>
          <div tw="bg-[#B40520] text-white p-8 lg:(col-span-2 pl-24)">
            <Heading level="h2" tw="text-white">
              <span tw="block text-xl">A Message From:</span>
              <span tw="block">Dr. Kathryn Nichol</span>
            </Heading>
            <p tw="text-base md:text-xl my-6">
            As my inaugural year as President and CEO of VHA Home HealthCare, 2021 will be a year to remember. With the ongoing COVID-19 pandemic, it was certainly a year that had significant challenges and we kept our Pandemic Response Team in action focused on the health and safety of our team and on providing high quality and safe care for clients and families. It was also a year where there was great progress towards the goal of integrated, neighbourhood-based care. 
            </p>
            <p tw="text-base md:text-xl my-6">
            VHA continued to build and strengthen relationships with Ontario Health Teams, hospitals and other health organizations to design and deliver new models of hospital-to-home, transitional and community-based care.
            </p>
            <p tw="text-base md:text-xl my-6">
            This past year we invested in improving and streamlining our care and services with a focus on communication and coordination and leveraging all that technology has to offer. In 2021, our focus on innovation and thought leadership has accelerated our learning and renewed our steadfast commitment to making care better through home care science.
            </p>
            <p tw="text-base md:text-xl my-6">
            I encourage you to read our 2021 Research and Innovation Annual Report, linked within this report, to see our progress in the areas of Data First, Powerful Partnerships and Creating Home Care Scientists.
            </p>
            <p tw="text-base md:text-xl my-6">
            When I reflect on what we have accomplished together, I feel inspired and am filled with gratitude – and as I look forward, VHA is well-positioned to embrace the changes ahead with our exceptional leadership and staff and service provider team and with the support of our dedicated volunteers, partners, funders, students, clients and caregivers. Thank you for your support and collaboration.
            </p>
          </div>
        </div>
        <div tw="my-8 lg:(grid grid-cols-3 my-12)">
          <div tw="lg:(col-span-1 -mr-12 mt-12)">
            <StaticImage src="../images/karen.jpg" alt="" />
          </div>
          <div tw="bg-gray-800 text-white p-8 lg:(col-span-2 pl-24)">
            <Heading level="h2" tw="text-white">
              <span tw="block text-xl">A Message From:</span>
              <span tw="block">Karen N. Singh</span>
            </Heading>
            <p tw="text-base md:text-xl my-6">
            This is a bittersweet moment for me as my term as Board Chair is coming to an end. That said, I will always look back over the past few years with tremendous gratitude. It has been a great privilege to serve this organization. This past year, the Board has continued to support the leadership team ensuring we could continue to provide necessary care to our vulnerable clients and keep everyone as safe as possible. The dedication and compassion of our front-line and office teams has been extraordinary. We were pleased to support a year-end bonus for all staff as a token of our appreciation.  We know it is the staff and service providers who live the values of VHA and we see that every day.
            </p>
            <p tw="text-base md:text-xl my-6">
            The Board’s responsibility is always to make sure there is a strong and stable foundation from which to build for the future. In 2021 this involved appointing a new President & CEO to lead the organization forward. It has been a pleasure to work with Kathryn in her inaugural year and inspiring to see VHA’s new leadership team leverage all that we have learned to advance the organization’s important work. I was also able to participate in the staff Town Hall on Diversity, Equity and Inclusion – a topic that is personal to me and one that I will continue to champion as we work to create safer spaces for our team members and our clients and families. 
            </p>
            <p tw="text-base md:text-xl my-6">
            I will always look back on this time with great fondness. It has been an honour to serve and experience VHA’s growth as a home care leader and I look forward to seeing what comes next!
            </p>
          </div>
        </div>
        <div tw="my-8 lg:(grid grid-cols-3 my-12)">
          <div tw="lg:(col-span-1 -mr-12 mt-12)">
            <StaticImage src="../images/amr.jpg" alt="" />
          </div>
          <div tw="bg-[#7182C5] text-gray-900 p-8 lg:(col-span-2 pl-24)">
            <Heading level="h2" tw="text-gray-900">
              <span tw="block text-xl">A Message From:</span>
              <span tw="block">Amr Elimam</span>
            </Heading>
            <p tw="text-base md:text-xl my-6">
            It has been both a privilege and a responsibility for VHA’s Client and Carer Advisory Council members to represent clients and provide counsel for VHA’s dedicated team members throughout the pandemic. We have tried to convey the many hardships home care clients and caregivers have experienced and provide insight on helpful supports and engagement. We have had the opportunity to discuss the ongoing health care human resources issue and examine ways to address it. And we have shared our appreciation for VHA’s continued prioritization of client-centred care, helping the most vulnerable clients stay safe at home receiving the care they need.
            </p>
            <p tw="text-base md:text-xl my-6">
            It has been energizing to see the launch of innovative initiatives such as digital transformation at VHA to address the needs of clients and caregivers and provide enhanced supports for staff and service providers. The development of advanced communication and navigation systems and the ongoing expansion of virtual care are exciting examples of the ways VHA is working to improve the client and caregiver experience.
            </p>
            <p tw="text-base md:text-xl my-6">
            Over this past year, the Client & Carer Advisory Council membership has expanded to better reflect the diversity of VHA’s clients. My colleagues on the Council and I look forward to continuing to work closely with VHA’s accomplished leadership team, remaining focused on what matters most to clients and families.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default MessagePage;
